import { render, staticRenderFns } from "./Join_us.vue?vue&type=template&id=4ec00797&scoped=true"
import script from "./Join_us.vue?vue&type=script&lang=js"
export * from "./Join_us.vue?vue&type=script&lang=js"
import style0 from "./Join_us.vue?vue&type=style&index=0&id=4ec00797&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec00797",
  null
  
)

export default component.exports